module.exports = __webpack_public_path__ + "static-web/media/boom.77c46e78.gif";